var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIndustry(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_831_586)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.9082 40.9549V27.3345L18.3622 24.0469V40.9549",
    strokeWidth: 2.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3631 40.8599V27.3335L26.8171 24.0458V46.5898M26.8171 46.5898H1.45508V27.3335L9.90909 24.0458V40.8599M26.8171 46.5898H46.5431V29.6818H26.8171V46.5898ZM40.9071 29.6818H32.4531L33.8621 15.5918H39.4981L40.9071 29.6818Z",
    strokeWidth: 2.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8621 46.5902V42.3632C33.8621 40.8068 35.1237 39.5452 36.6801 39.5452C38.2365 39.5452 39.4981 40.8068 39.4981 42.3632V46.5902M26.8171 35.3182H46.5431M1.45508 40.9542H26.8171M36.0532 7.03322C35.9224 7.03322 35.7939 7.0428 35.6677 7.0598C35.5815 4.87181 33.7813 3.12427 31.5722 3.12427C30.3934 3.12427 29.3316 3.6225 28.5838 4.41896C27.8131 2.64737 26.048 1.4082 23.9928 1.4082C21.9069 1.4082 20.1197 2.68448 19.3677 4.49852C18.3678 3.6425 17.0701 3.12437 15.6506 3.12437C12.4913 3.12437 9.93022 5.68546 9.93022 8.84473C9.93022 12.004 12.4913 14.5651 15.6506 14.5651C18.2292 14.5651 20.4088 12.8585 21.123 10.5134C21.9633 11.1039 22.9657 11.4202 23.9928 11.4189C25.6671 11.4189 27.1482 10.596 28.0569 9.33356C28.7739 10.5258 30.0798 11.3235 31.5723 11.3235C32.2204 11.3235 32.8329 11.1726 33.3777 10.9049C33.7863 11.9852 34.8298 12.7536 36.0533 12.7536C37.633 12.7536 38.9135 11.473 38.9135 9.8934C38.9134 8.31382 37.6329 7.03322 36.0532 7.03322Z",
    strokeWidth: 2.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_831_586"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndustry);
export default __webpack_public_path__ + "static/media/industry.9272996035bb0b976e35dfef4c8c23d8.svg";
export { ForwardRef as ReactComponent };